export default __webpack_public_path__ + "_/images/app/telegram/telegram-ru-1-5acf7dba011efd94381ee1a63f726aba5c698f4389587216769bcdc3e4b76c0c.jpg";